import React from "react";

export const NullComponent = () => null;
